import React from 'react';
import { Modal, Form, Input, Select } from 'antd';
import axios from 'axios';

const API_HOST_URL = process.env.REACT_APP_API_URL
  
  const LeaveBalanceDialogForm = Form.create({ name: 'form_in_modal' })(
    // eslint-disable-next-line
    class extends React.Component {

      state = {
        leaveTypes: [],
        employees: []
      }

      componentDidMount(){
        this.fetchLeaveTypes();
        this.fetchEmployees();
      }

      fetchLeaveTypes = () => {
        axios.get(`${API_HOST_URL}/api/leave/leavetype/`)
          .then(res => {
            this.setState({
              leaveTypes: res.data
            })
          })
      }

      fetchEmployees = () => {
        axios.get(`${API_HOST_URL}/api/employee/employee/`)
          .then(res => {
            this.setState({
              employees: res.data
            })
          })
      }

      handleSelectChange = (value) => {
        console.log(value);
        this.props.form.setFieldsValue({
          leaveType:  value
        });
      }

      handleSelectChange1 = (value) => {
        console.log(value);
        this.props.form.setFieldsValue({
          employee:  value
        });
      }

      render() {
        const { visible, onCancel, onCreate, form, data} = this.props;
        const { getFieldDecorator } = form;
        const { Option } = Select;

        return (
          <Modal
            visible={visible}
            title="Add Leave Balance"
            okText="Save"
            onCancel={onCancel}
            onOk={onCreate}>

            <Form layout="vertical">
            <Form.Item label="Leave Type">
                    {getFieldDecorator('leaveType', {
                      rules: [{ required: true, message: 'Please select leave type!' }],
                    })(
                      <Select
                        placeholder="Select Leave Type"
                        onChange={this.handleSelectChange}
                      >
                      {
                        this.state.leaveTypes.map(leaveType => 
                        <Option key={leaveType.id} value={ leaveType.id}>{ leaveType.leaveType }</Option>
                      )
                      }
                      </Select>
                    )}
              </Form.Item>

              <Form.Item label="Employee">
                    {getFieldDecorator('employee', {
                      rules: [{ required: true, message: 'Please select Employee!' }],
                    })(
                      <Select
                        showSearch
                        placeholder="Select Employee"
                        optionFilterProp="children"
                        onChange={this.handleSelectChange1}
                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                      >
                      {
                        this.state.employees.map(employee => 
                        <Option key={employee.id} value={ employee.id}>{ employee.firstName + ' ' + employee.lastName }</Option>
                      )
                      }
                      </Select>
                    )}
              </Form.Item>

              <Form.Item label="Leave Balance">
                {getFieldDecorator('leaveBalance', {
                 initialValue: data.leaveBalance,
                  rules: [{ required: true, message: 'Please input the Leave Balance!' }],
                })( <Input /> )}
              </Form.Item>

              <Form.Item label="Total Used">
                {getFieldDecorator('totalUsed', {
                 initialValue: data.totalUsed,
                  rules: [{ required: true, message: 'Please input the Total Used!' }],
                })( <Input /> )}
              </Form.Item>

              <Form.Item label="Brought Forward">
                {getFieldDecorator('broughtForward', {
                 initialValue: data.broughtForward,
                  rules: [{ required: false }],
                })( <Input /> )}
              </Form.Item>

              

              
            </Form>

          </Modal>
        );
      }
    }
  );

  export default LeaveBalanceDialogForm;
